// extracted by mini-css-extract-plugin
export var blackTheme = "HeaderNavigator-module--blackTheme--5ZQ8V";
export var isScrolled = "HeaderNavigator-module--is-scrolled--zzl9X";
export var isToggled = "HeaderNavigator-module--isToggled--f58Xn";
export var link = "HeaderNavigator-module--link--IsNjM";
export var list = "HeaderNavigator-module--list--AwcL9";
export var nav = "HeaderNavigator-module--nav--6a+LB";
export var selected = "HeaderNavigator-module--selected--ckcxd";
export var subscribeButton = "HeaderNavigator-module--subscribeButton--jhMM+";